import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { PqrFinalCausality } from '../../../../../../shared/types/modules/pqr';
import { PqrFinalCausalityProps } from './props';
import { asyncGetParams } from '../../../../../../services/param.service';

export const usePqrFinalCausality = ({
    data,
    onChangeData,
    onChangeFormik,
}: PqrFinalCausalityProps) => {
    const [causalities, setCausalities] = useState<ISelect[]>([]);
    const [motives, setMotives] = useState<ISelect[]>([]);
    const [protections, setProtections] = useState<ISelect[]>([]);

    const onSubmit = (data: PqrFinalCausality) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('causality', data?.causality || '');
        formik?.setFieldValue('motive', data?.motive || '');
        formik?.setFieldValue('protection', data?.protection || '');
    }, [data]);

    useEffect(() => {
        if (Boolean(formik.values.causality)) {
            asyncGetParams(
                ParamEnum.PQR_FINAL_CAUSALITY_MOTIVE,
                undefined,
                formik.values.causality
            ).then((items) => setMotives(items));
        }
        if (!data || !Boolean(data.motive)) {
            formik?.setFieldValue('motive', '');
        }
    }, [formik.values.causality]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_FINAL_CAUSALITY).then((items) =>
            setCausalities(items)
        );
        asyncGetParams(ParamEnum.PQR_FINAL_CAUSALITY_PROTECTION).then((items) =>
            setProtections(items)
        );
    }, []);

    return {
        formik,
        causalities,
        motives,
        protections,
    };
};
